import React, { Fragment } from 'react';
import * as types from 'legacy-src/constants/types';
import {
  youtubeLinkBySubject,
  APStudentCarousel,
  PreAPStudentCarousel,
  TODO_CARD_TYPES,
} from './constants';

export const cleanReturnPath = (returnPath) => {
  const i = returnPath.indexOf('?highlightElement');
  let newReturnPath = returnPath;
  if (i >= 0) {
    newReturnPath = returnPath.substring(0, i);
  }

  return newReturnPath;
};

const getYoutubeTodoCardData = (subject) => {
  const youtubeData = youtubeLinkBySubject[subject];
  const { headline, staticDate, message, link } = youtubeData || {};
  if (youtubeData && link) {
    const dateFragment = (staticDate || '').split(',');
    return {
      headline,
      icon: {
        name: 'youtube',
        width: 21,
        height: 21,
      },
      staticDate: staticDate ? (
        <Fragment>
          <div>{dateFragment[0]},</div>
          <div>{dateFragment[1].trim()}</div>
        </Fragment>
      ) : null,
      message,
      onClick: (event) => {
        window.open(link, '_blank');
        event.preventDefault();
      },
    };
  }

  return null;
};

export const getStudentCarrouselforProgram = (program, subject) => {
  if (program === types.AP) {
    const youtubeCarouselItem = getYoutubeTodoCardData(subject);
    if (youtubeCarouselItem) {
      APStudentCarousel.ITEMS.youtubeItem = youtubeCarouselItem;
    } else if (APStudentCarousel.ITEMS.youtubeItem) {
      APStudentCarousel.ITEMS.youtubeItem = null;
    }
    return APStudentCarousel;
  }
  return PreAPStudentCarousel;
};

export const getTodoCardType = ({
  isPracticeExam,
  isQB,
  isPPC,
  isLC,
  isPT,
  isDailyVideo,
  isWelcomeVideo,
  isSPP,
}) => {
  return (
    (isLC && TODO_CARD_TYPES.LEARNING_CHECKPOINT) ||
    (isPT && TODO_CARD_TYPES.PERFORMANCE_TASK) ||
    (isSPP && TODO_CARD_TYPES.SPP) ||
    (isQB && !isPracticeExam && TODO_CARD_TYPES.QUIZ) ||
    (isPPC && TODO_CARD_TYPES.PROGRESS_CHECK) ||
    (isPracticeExam && TODO_CARD_TYPES.PRACTICE_EXAM) ||
    (isDailyVideo && TODO_CARD_TYPES.DAILY_VIDEO) ||
    (isWelcomeVideo && TODO_CARD_TYPES.WELCOME_VIDEO) ||
    ''
  );
};
